"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRowActions = useRowActions;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var routes_1 = require("../../../../../constants/routes");
var client_1 = require("../../../../../reducers/slices/client/client");
var constants_1 = require("../constants");
function useRowActions() {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var openUser = (0, react_3.useCallback)(function (clientUser) {
        // the editor reads its draft from the slice, and older records predate fields like user_permissions
        dispatch((0, client_1.setSelectedClientUser)(__assign(__assign({}, constants_1.initialUserUpdateValues), clientUser)));
        navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.USERS_ROUTE, "/").concat(clientUser.user_id));
    }, [dispatch, navigate]);
    var rowActions = (0, react_3.useCallback)(function (clientUser) {
        var _a;
        return [
            {
                key: "view",
                element: ((0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, size: "sm", variant: "secondary", "aria-label": "View ".concat((_a = clientUser.name) !== null && _a !== void 0 ? _a : "user"), onPress: function () { return openUser(clientUser); }, children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "mdi:pencil" }) }, "view")),
            },
        ];
    }, [openUser]);
    return { rowActions: rowActions, openUser: openUser };
}
